<template>
  <v-row>
            <v-col>
              <v-container pb-4 grid-list-xl>
                <v-layout row wrap class="user-detailboxmain fixed-depositbox">
                  <v-flex class="user-detailbox">
                    <v-list-item v-for="insuranceDetails in savingAccountData" :key="insuranceDetails.id">
                      <v-list-item-content>
                        <v-list-item-title>
                          <h3 v-if="insuranceDetails.name">{{insuranceDetails.name}}</h3>
                          <h3 v-else>Account owner name is unavailable</h3> 
                        </v-list-item-title>
                        <v-list-item-subtitle v-for="savingAccountDatas in insuranceDetails.description" :key="savingAccountDatas.id">
                          <div class="account-detailbox">
                              <div class="bank-name">
                                 <span style="color: #7D7D7D;font-size: 11px;">Insurance Company</span>
                                <p v-if="savingAccountDatas.insurance_company">{{savingAccountDatas.insurance_company}}</p>
                                <p v-else>Company name is unavailable</p>
                                <h5 v-if="savingAccountDatas.policy_name">{{savingAccountDatas.policy_name}}</h5>
                                <h5 v-else>Policy name is unavailable</h5>
                                <p v-if="savingAccountDatas.insurance_certificate">{{savingAccountDatas.insurance_certificate}}</p>
                              </div>
                              <div class="amount-box">
                                <v-col class="memberbox-editbox">
                                  <v-menu bottom left offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        outlined fab
                                        color="#F19700"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="showHide(savingAccountDatas['form_id'])"
                                        v-if="allow_user_activity =='yes'"
                                      >
                                        <v-img max-height="20" max-width="20" :src="three_dots" :lazy-src="three_dots"></v-img>
                                      </v-btn>
                                    </template>
                                    <v-list v-if="(hideShowId == savingAccountDatas['form_id'])">
                                      <v-list-item>
                                        <v-list-item-title>
                                          <v-btn @click="editAccounts(savingAccountDatas['form_id'])">
                                            <v-img
                                            max-height="20"
                                            max-width="20"
                                            :src="edit_pic"
                                            :lazy-src="edit_pic"
                                            ></v-img> Edit
                                          </v-btn>
                                        </v-list-item-title>
                                      </v-list-item>
                                      <v-list-item>
                                        <v-list-item-title>
                                          <v-btn @click="deleteAccounts(savingAccountDatas['form_id'])">
                                            <v-img
                                            max-height="23"
                                            max-width="19"
                                            :src=" delete_pic"
                                            :lazy-src=" delete_pic"
                                            > </v-img>Delete
                                          </v-btn>
                                        </v-list-item-title>
                                      </v-list-item>
                                    </v-list>
                                  </v-menu>
                                </v-col>
                                <!-- <span>Total Contribution</span>
                                <p><span> &#8377;</span> {{savingAccountDatas.total_contribution}}</p> -->
                              </div>
                          </div>
                           <div class="maturity-Datebox">
                              <div class="bank-name">
                                <span>Policy Type</span>
                                <p v-if="savingAccountDatas.policy_type">{{savingAccountDatas.policy_type}}</p>
                                <p v-else>Policy Type is unavilable</p>
                              </div>
                              <div class="amount-box">
                                <span>Installment Permium</span>
                                <p><span> &#8377;</span> {{savingAccountDatas.installment_premium}} </p>
                              </div>
                          </div>
                          <div class="maturity-Datebox">
                              <div class="bank-name">
                                <span>Start Date</span>
                                <p v-if="savingAccountDatas.start_date">{{savingAccountDatas.start_date}}</p>
                                <p v-else>Start Date is unavilable</p>
                              </div>
                              <div class="amount-box">
                                <span>Sum Assured</span>
                                <p><span> &#8377;</span> {{savingAccountDatas.sum_assured}} </p>
                              </div>
                          </div>
                          <div class="maturity-Datebox Rate-of-Interest">
                              <div class="bank-name">
                                <span>Expiry Date</span>
                                <p v-if="savingAccountDatas.expiry_date">{{savingAccountDatas.expiry_date}}</p>
                                <p v-else>Maturity Date is unavailable</p>
                              </div>
                              <div class="amount-box">
                                
                              </div>
                          </div>
                           <div class="maturity-Datebox Rate-of-Interest">
                              <div class="bank-name">
                                <span>Insured Person</span>
                                <p v-for="item in savingAccountDatas.insured_person">{{item}}</p>
                              </div>
                              <div class="amount-box">
                                
                              </div>
                          </div>
                          <div class="maturity-Datebox">
                            <div class="bank-name">
                              <span>Nominees</span>
                              <p v-if="savingAccountDatas.nominee && savingAccountDatas.nominee.length != 0">
                                <span v-for="(items,index) in savingAccountDatas.nominee">{{items}}<span v-if="savingAccountDatas.nominee.length > index+1">, </span></span>
                              </p>
                              <p v-else>N/A</p>
                            </div>
                            <div class="" v-if="savingAccountDatas.is_matured == 'MATURED'">
                             <span style="color:#FF0000;"><b>{{savingAccountDatas.is_matured}}</b></span>
                            </div>
                          </div>
                         
                        </v-list-item-subtitle> 
                      </v-list-item-content>  
                    </v-list-item>
                  </v-flex>
                </v-layout>  
              </v-container>  
            <div class="total-amount-box" v-if="savingAccountData.length != 0">
                <h4>Group Insurance Sum Assured</h4>
                <div class="total-amount">
                  <span>As on {{currentDate | moment("DD MMM, Y")}}</span>
                  <p><span> &#8377;</span> {{amount.toLocaleString()}}</p>
                </div>
            </div>
            <div v-else>
              <v-list-item>
                <div class="user-detailbox">
                  <v-list-item-content>
                    <div class="text-h5 mb-1">
                     No data found.
                    </div>
                  </v-list-item-content>
                </div>
              </v-list-item>
            </div>
            </v-col>
        </v-row>
</template>
<script>
import { Auth } from "aws-amplify";
  import { POST_API, GET_API, DELETE_FORM, GET_INSURANCE_FORM_DETAIL } from "../../../../store/actions.type";
  import ApiService from "../../../../api/api.service";
  import JwtService from "../../.././common/jwt.service";
  import { isEmpty } from 'lodash';
  export default {
    data () {
      return {
       three_dots:process.env.VUE_APP_ROOT_ICONS_URL + 'three_dots.png',
       currentDate: new Date().setDate(new Date().getDate()),
        edit_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'edit.png',
        delete_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'delete.png',
        hideShow:false,
        hideShowId:'',
        full_name:'',
        allow_user_activity:localStorage.getItem('allow_user_activity')
      }
    },
    created(){
      Fire.$on("loadData", () => {
        this.savingAccountList();
      });
    },
    mounted () {
      if(this.isDataEmpty ) this.savingAccountList();
    },
    computed: {
      isDataEmpty: function () {
        return isEmpty(this.$store.getters.getInsuranceFormDetail);
      },
      savingAccountData: function () {
        return !this.isDataEmpty ? this.$store.getters.getInsuranceFormDetail.data.group_insurance_detail : [];
      },
      amount: function () {
        let amount = 0;
        this.$store.getters.getInsuranceFormDetail.balaces_details.balances.forEach(details => {
          if(details.acoount_type == 'Group Insurance')
          {
            amount +=  parseInt(details.balance);
          }
        })
        return amount;
      }
    },
    methods:{
     showHide(id){
        this.hideShowId = id;
        this.hideShow = this.hideShow ? false : true;
      },
      showHideAgain(id){
        if (this.hideShow == true) {
          //this.hideShow = false; 
        }

          //this.hideShow = true;
      },
      editAccounts(editId){
        this.$router.push({ path: "/edit-group/"+btoa(editId) }).catch(()=>{});
      },
      deleteAccounts(id){
          swal
        .fire({
          title: "Are you sure, you want to delete this data?",
          showCancelButton: true,
          confirmButtonColor: `#051d42`,
          confirmButtonText: `YES`,
          cancelButtonColor: `#f19700`,
        })
        .then(result => {
          if (result.isConfirmed) {
            let cognito_idp  = atob(localStorage.getItem('cognito_idp'));
            this.$store.dispatch(DELETE_FORM, {
              data: {
                aws_cognito_id: cognito_idp,
                form_id:id,
              },
              api: "delete-form",
            })
            .then(() => {
              this.savingAccountList();
              Toast.fire({
                    icon: 'success',
                    title: 'Data deleted successfully.'
              })
            });
          } else if (result.isDenied) {
            Swal.fire("Changes are not saved", "", "info");
          }
        });
      },
      savingAccountList(){
        this.$loading(true);
        let cognito_idp = atob(localStorage.getItem('cognito_idp'));
        let user_name = this.$store.getters.getUserDetails.user_name;
        let selected_value = this.$store.getters.getUserDetails.selected_value;
        this.$store.dispatch(GET_INSURANCE_FORM_DETAIL, {
          data: {
            aws_cognito_id: cognito_idp,
            user_name:user_name,
            member_id:selected_value,
          },
          api: "get-insurance-form-details",
        })
        .then(() => {
          Fire.$emit('insuranceGraphData');
          this.$loading(false);
        }).catch(() => {
          this.$loading(false);
        });
      },
    }
  }
</script>
